export const SPOTIFY_API_URL = 'https://api.spotify.com/v1';
export const EXP_PRODUCT_CODE = 'skyGo';
